module.exports = __webpack_public_path__ + "img/ring_r_skip_0_0.75d2e635.png";